import {GroupHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/GroupHeartStroke';
import {NewYorkHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/NewYorkHeartStroke';
import {OrdinaryHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/OrdinaryHeartStroke';

export type HeartStroke = OrdinaryHeartStroke | GroupHeartStroke | NewYorkHeartStroke;

type ExhaustiveHeartStrokeOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryHeartStroke) => TReturn;
  Group: (group: GroupHeartStroke) => TReturn;
  NewYork: (newYork: NewYorkHeartStroke) => TReturn;
};

type PartialHeartStrokeOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryHeartStroke) => TReturn;
  Group?: (group: GroupHeartStroke) => TReturn;
  NewYork?: (newYork: NewYorkHeartStroke) => TReturn;
  _: (app: HeartStroke) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: HeartStrokeByTypeOptions<TReturn>
): options is ExhaustiveHeartStrokeOptionsByType<TReturn> =>
  !!options.Ordinary || (!!options.Group && !!options.NewYork);

type HeartStrokeByTypeOptions<TReturn> =
  | PartialHeartStrokeOptionsByType<TReturn>
  | ExhaustiveHeartStrokeOptionsByType<TReturn>;

export const matchHeartStrokeByType = <TReturn>(options: HeartStrokeByTypeOptions<TReturn>) => (
  app: HeartStroke
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryHeartStroke':
    case 'ValidOrdinaryHeartStroke':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupHeartStroke':
    case 'ValidGroupHeartStroke':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkHeartStroke':
    case 'ValidNewYorkHeartStroke':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidHeartStroke = (heartStroke: HeartStroke) =>
  heartStroke.key === 'ValidOrdinaryHeartStroke' ||
  heartStroke.key === 'ValidGroupHeartStroke' ||
  heartStroke.key === 'ValidNewYorkHeartStroke';
